import {
  ApproveRejectResponse,
  BookingStatus,
  EmployeeApi,
  HolidayDecisionProps,
  TextareaStyled,
  useHolidayBooking,
} from '@abdoo/common';
import { CancelOutlined, InfoOutlined } from '@mui/icons-material';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';

export const ApproveReject = (props: HolidayDecisionProps) => {
  const [error, setError] = useState<any | null>(null);
  const [data, setData] = useState<ApproveRejectResponse>();
  const [isAlreadyDecided, setIsAlreadyDecided] = useState<boolean>(false);
  const [rejectionReason, setRejectionReason] = useState<string>('');

  const { sendDecision, holidayStatus } = useHolidayBooking(EmployeeApi, props.bookingId);

  const SendRejectDecision = useCallback(async () => {
    if (rejectionReason) {
      await sendDecision().mutationAsync(setData, setError, {
        bookingId: props.bookingId,
        approveOrReject: 'reject',
        rejectionReason,
      });
    } else {
      setError('Please give a reason to complete this rejection.');
    }
  }, [props.bookingId, rejectionReason, sendDecision]);

  useEffect(() => {
    if (holidayStatus.data && !data?.success) {
      if (holidayStatus.data === BookingStatus.Rejected) {
        setError("You've already rejected that absence");
        setIsAlreadyDecided(true);
        return;
      } else if (holidayStatus.data === BookingStatus.Approved) {
        setError("You've already approved that absence");
        setIsAlreadyDecided(true);
        return;
      }

      if (props.approveOrReject === 'approve' && !sendDecision().isLoading) {
        try {
          sendDecision().mutation(setData, setError, props);
        } catch (e) {
          setError(e);
        }
      }
    }
    // We do not want to run this effect when sendDecision changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holidayStatus.data, props]);

  const handleReasonChange = useCallback((event: any) => {
    setRejectionReason(event.target.value);
  }, []);

  const infoIcon = (
    <InfoOutlined sx={{ color: 'info.main', marginRight: '0.5rem' }}></InfoOutlined>
  );

  return (
    <Grid
      container
      gap={2}
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Box display="flex" justifyContent="center" alignItems="flex-start">
        {(props.approveOrReject === 'approve' ||
          (props.approveOrReject === 'reject' && (error || data))) &&
          (error ? (
            <>
              <CancelOutlined
                sx={{ color: 'error.main', marginRight: '0.5rem' }}
              ></CancelOutlined>
              {error}
            </>
          ) : sendDecision()?.isLoading ? (
            <CircularProgress />
          ) : !props.bookingId ? (
            <>{infoIcon}Holiday booking not found.</>
          ) : (
            <>
              {infoIcon}
              {data?.message}
            </>
          ))}
      </Box>
      {props.approveOrReject === 'reject' &&
        !isAlreadyDecided &&
        !data &&
        !holidayStatus.isLoading && (
          <Box>
            <Grid mb={2} container direction="column" alignItems="flex-start">
              <p>Enter reason for rejection</p>
              <TextareaStyled
                width="20rem"
                minRows={4}
                value={rejectionReason}
                onChange={handleReasonChange}
              />
            </Grid>
            <Button variant="contained" color="primary" onClick={SendRejectDecision}>
              Reject request
            </Button>
          </Box>
        )}
    </Grid>
  );
};
